import { PlanInterval } from './types';

const AdditionalMemberPrice: Record<PlanInterval, number> = {
  Monthly: 8,
  Yearly: 80
};

export default AdditionalMemberPrice;
